import React, { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import List from "devextreme-react/list";
import { useAuth } from "../../contexts/auth";
import { isAdminRoleChecker, isEmployeeRoleChecker } from "../../utils/roleChecker";
import { USER_ROLES } from "../../constants/roles";
import "./AdministrationPanelPage.scss";

const STAFF_MENU_PATH = "/admin-impersonation";

const AdministrationPanelPage = () => {
  const history = useHistory();
  const { user } = useAuth();
  const isAdmin = isAdminRoleChecker(user, USER_ROLES.ADMIN);
  const isEmployee = isEmployeeRoleChecker(user);

  const adminMenuItems = useMemo(() => {
    const items = [
      {
        id: 1,
        text: "Статистика посещений",
        icon: "chart",
        path: "/audit-stats",
        description: "Просмотр статистики посещений пользователей",
        adminOnly: true,
      },
      {
        id: 2,
        text: "Аудит пользователей",
        icon: "group",
        path: "/audit-log",
        description: "Таблица с полным аудитом пользователей",
        adminOnly: true,
      },
      {
        id: 3,
        text: "Пользователи ЛК",
        icon: "runner",
        path: STAFF_MENU_PATH,
        description: "Список всех пользователей",
        adminOnly: false,
      },
      {
        id: 4,
        text: "Сервисный режим",
        icon: "video",
        path: "/admin-maintenance",
        description: "Включить/выключить/продлить",
        adminOnly: true,
      },
      {
        id: 5,
        text: "Прочее",
        icon: "preferences",
        path: "/admin-other",
        description: "Перезагрузка данных, настройки",
        adminOnly: true,
      },
    ];

    if (isAdmin) {
      return items;
    }

    return items.filter((item) => isEmployee && !item.adminOnly);
  }, [isAdmin, isEmployee]);

  const handleItemClick = useCallback((e) => {
    const item = e.itemData;
    if (item && item.path) {
      history.push(item.path);
    }
  }, [history]);

  return (
    <div className="admin-panel-page">
      <div className="container-fluid responsive-paddings">
        <div className="admin-panel-header">
          <h1 className="admin-panel-title">Панель администратора</h1>
          <p className="admin-panel-subtitle">
            Управление системой и контроль доступа
          </p>
        </div>
        <div className="admin-menu-container">
          <List
            dataSource={adminMenuItems}
            onItemClick={handleItemClick}
            activeStateEnabled={false}
            itemRender={(data) => (
              <div className="admin-menu-item">
                <div className="admin-menu-item-icon">
                  <i className={`dx-icon dx-icon-${data.icon}`}></i>
                </div>
                <div className="admin-menu-item-content">
                  <div className="admin-menu-item-title">{data.text}</div>
                  {data.description && (
                    <div className="admin-menu-item-description">
                      {data.description}
                    </div>
                  )}
                </div>
                <div className="admin-menu-item-arrow">
                  <i className="dx-icon dx-icon-chevronright"></i>
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default AdministrationPanelPage;
